
import { reactive, ref, toRefs, unref, onMounted, defineComponent } from "vue";
//引入vue方法
import { ElConfigProvider } from "element-plus";
import type { ElForm } from "element-plus";
//中文包
import { useRouter } from "vue-router";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { getAbout, delAbout } from "@/api/backstage";
import { ElMessage } from "element-plus";
import { getEnum } from "@/api/index";
type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  name: "关于我们",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  setup() {
    let locale = zhCn;
    const router = useRouter();
    const dataMap: any = reactive({
      ruleFormRef: ref<FormInstance>(),
      aboutUsType: {},
      drawer: false,
      newsInfo: "",
      status: {},
      tableData: [],
      total: 0,
      time: "",
      form: {
        title: "",
        pageNum: 1,
        pageSize: 10,
      },
      async getList() {
        const data = await getAbout(this.form);
        dataMap.tableData = data?.data.list ?? [];
        dataMap.total = data?.data.total ?? 0;
      },

      async getAboutType() {
        dataMap.aboutUsType = {};
        const menus = await getEnum("ABOUT_US");
        for (const item of menus.data) {
          dataMap.aboutUsType[item.enumKey] = item;
        }
      },
 
      
      async delDataList(ids: any) {
        const baseId = { id: ids };
        const res = await delAbout(baseId);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          dataMap.getList();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
       
    });
    const onSubmit = () => {
      dataMap.getList();
    };

    const resetForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
      dataMap.getList();
    };

    const handleSizeChange = (val: number) => {
      dataMap.form.pageSize = val;
      dataMap.getList();
    };
    const handleCurrentChange = (val: number) => {
      dataMap.form.pageNum = val;
      dataMap.getList();
    };

    const confirmEvent = (row: any, index: any) => {
      dataMap.delDataList(row.id);
    };
 
    onMounted(() => {
      dataMap.getList();
      dataMap.getAboutType();
    });

    return {
      locale,
      close,
      onSubmit,
      resetForm,
 
      router,
      confirmEvent,
      handleSizeChange,
      handleCurrentChange,
      ...toRefs(dataMap),
    };
  },
});
